import { useEffect } from "react";
import { logoutToken } from "../service/api/token";

export default function Logout() {
    useEffect(() => {
        logoutToken();
        localStorage.clear();
        window.location.href = '/'
    }, [])
}